import { get } from "..";
import { Query, ReportCategories } from "../../screens/Reports/types";

export function reports(
  id: ReportCategories,
  query: Partial<Query> = { limit: 10, page: 1 }
) {
  return get(`tickets/reports/${id}`, query);
}
